import './FormFieldWrapper.scss';
import React, { ReactNode } from 'react';
import classnames from 'classnames';
import ErrorMessage from '../ErrorMessage/ErrorMessage';

type Props = {
  label?: string;
  labelNote?: string;
  children: ReactNode;
  touched?: boolean;
  error?: any; // The type from should be string but is wrong from Formik
  className?: string;
  horizontal?: boolean;
};

const FormFieldWrapper = (props: Props) => {
  const { label, labelNote, children, error, touched, horizontal, className } =
    props;
  const classList = classnames(
    'form-field-wrapper',
    horizontal && 'form-field-wrapper--horizontal',
    className,
  );

  return (
    <div className={classList}>
      {label && (
        <div className="form-field-wrapper__label-wrapper">
          {' '}
          <label className="form-field-wrapper__label">{label}</label>
          {labelNote && (
            <span className="form-field-wrapper__label-note">{labelNote}</span>
          )}
        </div>
      )}

      <div className="form-field-wrapper__input">{children}</div>

      {touched && error && (
        <ErrorMessage displayType="triangle" error={error} />
      )}
    </div>
  );
};

export default FormFieldWrapper;
